module.exports = __webpack_public_path__ + "img/detallecurso6.735cf611.png";